import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { capitalize } from '@/helpers/filters'
import * as moment from 'moment'
import { EVENT_NAME__REMINDER_CREATED, EVENT_NAME__REMINDER_UPDATED, ReminderWrite } from '@/api/RemindersApi'
import { Uuid } from '@/types/api'
import { computed, onBeforeMount, reactive, ref } from 'vue'
import { FormKitSchemaNode } from '@formkit/core'
import { BaseLock, BaseProps, FormManager } from '@/uiManagers/FormManager'
import { PromiseParallelAction } from '@/helpers/tools'
import { Reminder } from '@/types/api/reminder'
import { remindersApi } from '@/di/api'
import eventBus from '@/di/eventBus'
import { useRouter } from "vue-router";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";

type Model = ReminderWrite

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Lock extends BaseLock {

}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props extends BaseProps {
  itemId?: Uuid
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReminderForm',
  props: {
    itemId: null
  },
  setup(__props: any) {

const props = __props as {
  itemId?: Uuid
};

class ReminderFormManager extends FormManager<Reminder, Props, Lock> {
}

const router = useRouter()



const model = ref<Model>(({ title: '', description: '', action_at: moment().format('YYYY-MM-DD[T]HH:mm') }))

const lock = reactive<Lock>({ preparing: false, formSubmitting: false })

const reminderFormManager: ReminderFormManager = new ReminderFormManager(
    'reminder',
    router,
    eventBus,
    props,
    (): Model => ({
      title: model.value.title,
      description: model.value.description,
      action_at: moment(model.value.action_at).format('YYYY-MM-DD[T]HH:mm:ssZ')
    }),
    lock,
    {
      resolveItem: (itemId: Uuid): PromiseParallelAction<Reminder> => ({
        promise: () => remindersApi.getReminder(itemId),
        resolve: (response): void => {
          model.value.title = response.title
          model.value.description = response.description
          model.value.action_at = moment(response.action_at).format('YYYY-MM-DD[T]HH:mm')
        }
      } as PromiseParallelAction<Reminder>),
      create: ((submitData: Model): Promise<void> => remindersApi.createReminder(submitData)) as (submitData: object) => Promise<void>,
      update: ((id: Uuid, submitData: Model): Promise<void> => remindersApi.updateReminder(id, submitData)) as (id: Uuid, submitData: object) => Promise<void>
    },
    {
      created: EVENT_NAME__REMINDER_CREATED,
      updated: EVENT_NAME__REMINDER_UPDATED
    },
    { name: 'reminders-list' }
)

const formSchema = computed<FormKitSchemaNode[]>((): FormKitSchemaNode[] => ([
  {
    $formkit: 'text',
    name: 'title',
    label: 'Title',
    validation: 'required',
    disabled: isUpdate.value && lock.preparing,
    outerClass: 'mb-3'
  },
  {
    $formkit: 'textarea',
    name: 'description',
    label: 'Description',
    disabled: isUpdate.value && lock.preparing,
    outerClass: 'mb-3'
  },
  {
    $formkit: 'datetime-local',
    name: 'action_at',
    label: 'Action at',
    disabled: isUpdate.value && lock.preparing,
    outerClass: 'mb-3'
  }
]))

const operation = computed<string>((): string => isCreate.value ? 'add' : 'update')
const isCreate = computed<boolean>((): boolean => reminderFormManager.isCreate())
const isUpdate = computed<boolean>((): boolean => reminderFormManager.isUpdate())

const submit = reminderFormManager.getSubmit()

onBeforeMount(async (): Promise<void> => {
  await reminderFormManager.prepareForm()
})

return (_ctx: any,_cache: any) => {
  const _component_FormKitSchema = _resolveComponent("FormKitSchema")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    type: "form",
    actions: false,
    onSubmit: _unref(submit)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_FormKitSchema, { schema: _unref(formSchema) }, null, 8, ["schema"]),
      _createVNode(_component_FormKit, {
        type: "submit",
        "input-class": "btn btn-primary btn-sm"
      }, {
        default: _withCtx(() => [
          _createVNode(FormKitSubmitButtonContent, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(capitalize)(_unref(operation))), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onSubmit"]))
}
}

})